module.exports = __webpack_public_path__ + "img/I-7.5a648104.svg";